<template>
  <div>
    <!-- Modal for expiration date selection -->
    <b-modal
      :ok-title="readOnly ? 'Cerrar' : 'Aceptar'"
      :ok-variant="readOnly ? 'secondary' : 'primary'"
      ok-only
      id="workshop-date-modal"
      size="lg"
      @shown="workshopDateModalShown"
      @ok="okBtn"
      @cancel="modalCancel"
      @close="modalClose"
      title="Modificando fecha límite"
    >
      <b-row>
        <b-col cols="12"
          ><p>
            En el calendario de la izquierda, en
            <span class="text-info">azul</span>, se muestran los días con
            pedidos que cumplen el plazo límite. <br />En la tabla de la derecha
            se muestran el listado de pedidos (en
            <span class="text-info">azul</span> el pedido que se está editando).
          </p>
          <p>Haz click en un día para mostrar los pedidos de ese día.</p></b-col
        >
      </b-row>
      <b-row>
        <b-col cols="auto">
          <b-calendar
            :date-info-fn="dateClass"
            v-model="deadlineWorkshopOverride"
            locale="es-ES"
            start-weekday="1"
            :hide-header="true"
            @input="deadlineDateSelected"
          ></b-calendar>
        </b-col>
        <b-col cols="auto">
          <b-button
            class="mb-3"
            @click="resetTable"
            :disabled="
              this.deadlineModal.uncompletedOrders.length ===
              this.deadlineModal.uncompletedOrdersShown.length
            "
            size="sm"
            >Mostrar todos</b-button
          >
          <b-table
            :fields="deadlineModal.fields"
            striped
            hover
            :items="deadlineModal.uncompletedOrdersShown"
          >
            <template #cell(deadline_workshop)="data">
              {{ data.item.deadline_workshop | formatDateTime }}
            </template>

            <template #cell(total_price)="data">
              <span>{{ data.item.total_price }} €</span>
            </template>

            <template #cell(id)="data">
              <b-link
                target="_blank"
                :to="{
                  name: 'AdminOrdersEditScreen',
                  params: { id: data.item.id },
                }"
                >{{ data.item.id }}</b-link
              >
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'OpenOrdersModal',
  props: {
    id: String,
    readOnly: Boolean,
    valDeadlineWorkshopOverride: Object,
  },
  components: {},
  data() {
    return {
      deadlineWorkshopOverride: null,
      deadlineModal: {
        uncompletedOrders: [],
        uncompletedOrdersShown: [],
        fields: [
          { key: 'id', label: '# Pedido' },
          { key: 'deadline_workshop', label: 'Fecha límite' },
          { key: 'total_price', label: 'Precio' },
          {
            key: 'first_name',
            label: 'Nombre cliente',

            formatter: (value, key, item) => {
              return item.first_name + ' ' + item.last_name;
            },
          },
        ],
        options: {
          headings: {
            deadline_workshop: 'Fecha límite',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {
    this.deadlineWorkshopOverride = this.valDeadlineWorkshopOverride;
  },
  filters: {
    formatDateTime: function (value) {
      return moment(value).format('DD/MM/YYYY');
    },
  },
  methods: {
    okBtn() {
      if (!this.readOnly) {
        this.$emit('newDeadline', this.deadlineWorkshopOverride);
      }
    },
    resetTable() {
      this.deadlineModal.uncompletedOrdersShown = this.deadlineModal.uncompletedOrders;
    },
    dateClass(ymd, date) {
      return this.deadlineModal.uncompletedOrders.findIndex((x) => {
        return x.deadline_workshop === ymd;
      }) >= 0
        ? 'table-info'
        : '';
    },
    deadlineDateSelected(val) {
      this.deadlineModal.uncompletedOrdersShown = this.deadlineModal.uncompletedOrders.filter(
        (x) => x.deadline_workshop === val
      );
    },
    workshopDateModalShown() {
      actions.getOrdersUncompleted().then((x) => {
        this.deadlineModal.uncompletedOrders = x.data;
        this.deadlineModal.uncompletedOrdersShown = x.data.map((y) => {
          if (!this.readOnly) {
            if (y.id === parseInt(this.id)) {
              y['_rowVariant'] = 'info';
            }
          }
          return y;
        });
      });
    },
    modalCancel() {
      deadlineWorkshopOverride = null;
    },
    modalClose() {
      deadlineWorkshopOverride = null;
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
